import { Route } from "@faire/web-api/Route";
import { props as discoverRouteProps } from "@faire/web-api/routes/discover/searchTerm";
import React, { lazy } from "react";

import { createDependencyInjectableComponent } from "@faire/retailer/app/_lib/dependencyInjectableComponent";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";
import { useMaybePrefetchDiscoverPage } from "@faire/retailer/views/discover/__internal__/prefetch/useMaybePrefetchDiscoverPage";

export const renderDiscoverPageRoute = () => {
  /* For SEO purpose, we want support URL `/discover/candle` besides
   * `/search?q=candle` but still want the q from query param to take precedence
   * ie, `/discover/candle?q=notCandle` will display results for query
   * `notCandle` instead of `candle`
   */

  return (
    <Route
      {...discoverRouteProps}
      component={LazyDiscoverPageWithClientSidePrefetch}
    />
  );
};

const LazyDiscoverPageWithClientSidePrefetch: React.FC = () => {
  useMaybePrefetchDiscoverPage();
  const DiscoverPage = useDiscoverPage();
  return <DiscoverPage />;
};

const LazyDiscoverPageNoPrefetch = lazy(() =>
  import(
    /* webpackChunkName: "discover-page" */ "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DiscoverPage"
  )
    .then((m) => ({ default: m.DiscoverPage }))
    .catch(handleComponentLoadError)
);

const { useDependencyInjectableComponent: useDiscoverPage } =
  createDependencyInjectableComponent(LazyDiscoverPageNoPrefetch);
